import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { LoadingProvider, useLoading, setGlobalLoadingFunctions } from './contexts/LoadingContext';
import { AlertProvider } from './contexts/AlertContext';
import LoadingSpinner from './components/LoadingSpinner';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import EmailVerifyPage from './pages/EmailVerifyPage';
import IntroPage from './pages/IntroPage';
import MainPage from './pages/MainPage';
import VisionPage from './pages/VisionPage';
import OverviewPage from './pages/OverviewPage';
import RecognitionPage from './pages/RecognitionPage';
import RewardPage from './pages/RewardPage';
import EducationPage from './pages/EducationPage';
import AdminPage from './pages/AdminPage';
import './App.css';

// 전역 로딩 함수 설정 컴포넌트
function LoadingInitializer() {
  const { startLoading, stopLoading } = useLoading();

  useEffect(() => {
    setGlobalLoadingFunctions(startLoading, stopLoading);
  }, [startLoading, stopLoading]);

  return null;
}

// 로딩 스피너 표시 컴포넌트
function GlobalLoadingSpinner() {
  const { isLoading } = useLoading();
  return isLoading ? <LoadingSpinner /> : null;
}

function App() {
  return (
    <LoadingProvider>
      <LoadingInitializer />
      <GlobalLoadingSpinner />
      <AlertProvider>
        <AuthProvider>
        <PermissionProvider>
          <Router basename="/cis-v2">
            <div className="App">
              <Routes>
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/email-verify" element={<EmailVerifyPage />} />
                <Route path="/intro" element={<IntroPage />} />
                <Route path="/main" element={<MainPage />} />
                <Route path="/vision" element={<VisionPage />} />
                <Route path="/overview" element={<OverviewPage />} />
                <Route path="/recognition" element={<RecognitionPage />} />
                <Route path="/reward" element={<RewardPage />} />
                <Route path="/education" element={<EducationPage />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </div>
          </Router>
        </PermissionProvider>
        </AuthProvider>
      </AlertProvider>
    </LoadingProvider>
  );
}

export default App;
